import { supabase } from './supabase'
import { requireAuth } from './auth'
import type { Database } from '@/types/database'

export type UserProfile = Database['public']['Tables']['users']['Row']

export const getUserProfile = async (): Promise<UserProfile | null> => {
  const userId = await requireAuth()

  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .maybeSingle()

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export const completeOnboarding = async ({
  writingType,
}: {
  writingType: string | null
}): Promise<void> => {
  const userId = await requireAuth()

  const { error } = await supabase
    .from('users')
    .upsert({
      id: userId,
      onboarding_completed_at: new Date().toISOString(),
      onboarding_writing_type: writingType,
    })

  if (error) {
    throw new Error(error.message)
  }
}
